let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lqjpG")).then(() => parcelRequire('hUJwi'));